import AddIcon from '@mui/icons-material/Add';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Box, Chip, Collapse, IconButton, Tooltip } from '@mui/material';
import React from 'react';
import { DARK, ORANGE, statusChipSx } from 'src/components/dynamicCatalogStyles';

export const isTruthyFlag = (v) => v === true || v === 1 || v === '1';

const normalize = (v) => (v === null || v === undefined ? '' : v.toString().toLocaleLowerCase('tr-TR'));

/*
  Üst kayıt + açılır detay listesi (Onay Türü, Değişim Nedeni vb.)
  Arama yapılırsa eşleşen gruplar otomatik açılır; grup adı eşleşirse tüm detayları görünür.
*/
function DynamicGroupList({
  groups,
  openKeys,
  onToggle,
  searchText,
  getGroupKey,
  getGroupLabel,
  isGroupActive,
  getDetails,
  getDetailKey,
  getDetailLabel,
  isDetailActive,
  renderDetailActions,
  onAddInGroup,
  addInGroupTooltip = 'Bu gruba ekle',
  emptyText = 'Kayıt bulunamadı.'
}) {
  const q = normalize(searchText).trim();

  const visibleGroups = (groups || [])
    .map((g) => {
      const details = getDetails(g) || [];
      if (!q) return { g, details, forceOpen: false };
      const groupMatch = normalize(getGroupLabel(g)).includes(q);
      const matchedDetails = groupMatch ? details : details.filter((d) => normalize(getDetailLabel(d)).includes(q));
      if (!groupMatch && matchedDetails.length === 0) return null;
      return { g, details: matchedDetails, forceOpen: true };
    })
    .filter(Boolean);

  if (visibleGroups.length === 0) {
    return <Box sx={{ p: '32px 16px', textAlign: 'center', color: '#90a4ae', fontSize: '12px' }}>{q ? 'Aramaya uygun kayıt bulunamadı.' : emptyText}</Box>;
  }

  return (
    <Box>
      {visibleGroups.map(({ g, details, forceOpen }) => {
        const key = getGroupKey(g);
        const open = forceOpen || openKeys.has(key);
        const groupActive = isGroupActive(g);
        const activeDetailCount = details.filter(isDetailActive).length;
        return (
          <Box key={key} sx={{ borderBottom: '1px solid #f0f0f0' }}>
            <Box
              onClick={() => onToggle(key)}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                p: '10px 16px',
                cursor: 'pointer',
                backgroundColor: open ? '#fffaf2' : '#fff',
                borderLeft: `3px solid ${open ? ORANGE : 'transparent'}`,
                '&:hover': { backgroundColor: '#fff8e1' }
              }}
            >
              <ExpandMoreIcon sx={{ fontSize: 20, color: '#90a4ae', transition: 'transform 0.2s', transform: open ? 'rotate(0deg)' : 'rotate(-90deg)' }} />
              <Box sx={{ flex: 1, minWidth: 0, fontSize: '13px', fontWeight: 700, color: groupActive ? DARK : '#90a4ae' }}>
                {getGroupLabel(g)}
              </Box>
              <Box sx={{ fontSize: '11px', color: '#78909c', whiteSpace: 'nowrap' }}>
                {details.length} detay{details.length > 0 ? ` · ${activeDetailCount} aktif` : ''}
              </Box>
              <Chip size="small" label={groupActive ? 'Aktif' : 'Pasif'} sx={statusChipSx(groupActive)} />
              {onAddInGroup && (
                <Tooltip title={groupActive ? addInGroupTooltip : 'Pasif gruba ekleme yapılamaz'}>
                  <span>
                    <IconButton
                      size="small"
                      disabled={!groupActive}
                      onClick={(e) => { e.stopPropagation(); onAddInGroup(g); }}
                    >
                      <AddIcon sx={{ fontSize: 18, color: groupActive ? ORANGE : undefined }} />
                    </IconButton>
                  </span>
                </Tooltip>
              )}
            </Box>
            <Collapse in={open} timeout="auto" unmountOnExit>
              <Box sx={{ backgroundColor: '#fafafa', borderTop: '1px solid #f0f0f0' }}>
                {details.length === 0 && (
                  <Box sx={{ p: '10px 16px 10px 52px', fontSize: '12px', color: '#90a4ae' }}>Bu gruba ait detay yok.</Box>
                )}
                {details.map((d) => {
                  const detailActive = isDetailActive(d);
                  return (
                    <Box
                      key={getDetailKey(d)}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1.5,
                        p: '6px 16px 6px 52px',
                        borderBottom: '1px solid #f0f0f0',
                        '&:last-of-type': { borderBottom: 'none' },
                        '&:hover': { backgroundColor: '#fff8e1' }
                      }}
                    >
                      <Box sx={{ width: 6, height: 6, borderRadius: '50%', backgroundColor: detailActive ? '#43a047' : '#e53935', flexShrink: 0 }} />
                      <Box sx={{ flex: 1, minWidth: 0, fontSize: '12px', color: detailActive ? '#263238' : '#90a4ae' }}>
                        {getDetailLabel(d)}
                      </Box>
                      <Chip size="small" label={detailActive ? 'Aktif' : 'Pasif'} sx={statusChipSx(detailActive)} />
                      {renderDetailActions && renderDetailActions(d, g)}
                    </Box>
                  );
                })}
              </Box>
            </Collapse>
          </Box>
        );
      })}
    </Box>
  );
}

export default DynamicGroupList;
